
import { Options, Vue, mixins } from 'vue-class-component';
import WithModel from '@/components/standard/formFieldPlugin/mixins/withModel';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/Model';

@Options({
    components: {
    }
})
export default class selectGarmentProperties extends mixins(WithModel) {

    declare localValue: OM.GarmentPropertyLayer;
    @Prop() index: number; 
    @Prop() garmentConfiguration: OM.MyGarmentConfigurationsVM; 
    @Prop({
        default: false
    }) isReadOnly: boolean;
    
    localGarmentConfiguration: OM.MyGarmentConfigurationsVM = new OM.MyGarmentConfigurationsVM();
    // updateListCheck: number = 0;
    
    created() {
        this.localGarmentConfiguration = {...this.garmentConfiguration};
        // this.changedFilteredValues();
        this.populateProperties();
    }

    populateProperties() {
        const filtered = this.filteredValues;
        
        filtered.forEach(filteredValue => {
            const found = this.localValue.properties.find(p => p.propertyName === filteredValue.propertyName);
            if (found) return;

            const model = new OM.GarmentProperty();
            model.propertyName = filteredValue.propertyName;
            model.propertyValue = "";
            this.localValue.properties.push(model);
        });

        // this.updateListCheck = Math.random();
    }

    @Watch('localValue.gender')
    onGenderChanged() {
        this.populateProperties();
    }

    // @Watch("filteredValues", {deep: true})
    // changedFilteredValues(){
    //     // this.localGarmentConfiguration.garmentLayersPropertyValues[this.index].propertyValues = this.garmentConfiguration.garmentLayersPropertyValues[this.index].propertyValues.filter( x => {
    //     //     return x.gender == this.localValue.gender
    //     // })

    //     this.filteredValues.forEach(filteredValue => {
    //         var found = this.localValue.properties.find( x => x.propertyName == filteredValue.propertyName);
            
    //         if(found)
    //             return;

    //         var model = new OM.GarmentProperty();
    //         model.propertyName = filteredValue.propertyName;
    //         model.propertyValue = "";

    //         this.localValue.properties.push(model);
    //     });

    //     this.updateListCheck = Math.random();
    // }

    get isSQMNotToShow() {
        if(this.garmentConfiguration.name == "BRA" ||
            this.garmentConfiguration.name == "BOTTOM UNDERWEAR" ||
            this.garmentConfiguration.name == "LINGERIE" ||
            this.garmentConfiguration.name == "PAJAMAS"
        )
            return true;
        else
            return false;
    }

    get filteredValues(){
        if(!this.localGarmentConfiguration.garmentLayersPropertyValues[this.index])
            return [];

        return this.localGarmentConfiguration.garmentLayersPropertyValues[this.index].propertyValues.filter( x => x.gender == this.localValue.gender);
    }

    filteredPropertyValues(propertyName: string){
        var originalFilteredList = this.filteredValues.filter( x => {
            if(x.propertyName == propertyName)
                return x;
        })
        .map( x => x.values)
        .reduce((a, b) => { return a.concat(b); }, [])
        .map( x => {
            return {
                identifier: x.label,
                text: x.label,
                parent: x.parentLabelValue
            }
        })

        var ris = this.filterItemsBySelectedProperties(originalFilteredList, this.localValue.properties);
        // this.updateListCheck = Math.random();
        return ris;
    }

    filterItemsBySelectedProperties(possibleItems, selectedProperties) {
        // Costruisco un Set per accesso veloce ai valori selezionati
        const selectedValues = new Set(
            selectedProperties.map(item => item.propertyValue)
        );

        // Filtro gli elementi
        return possibleItems.filter(item => {
            // Se non ha parent, includilo
            if (!item.parent) return true;
            
            // Se ha un parent, includilo solo se il parent è presente nei valori selezionati
            return selectedValues.has(item.parent);
        });
    }

    valueChanged(propertyValue: string, propertyName: string){
        if (!propertyValue) return;

        const filteredValue = this.filteredValues.find(x => x.propertyName === propertyName);
        const values = filteredValue?.values || [];
        const value = values.find(x => x.label === propertyValue)?.value;

        const currentProperty = this.localValue.properties.find(x => x.propertyName === propertyName);
        if (currentProperty) {
            currentProperty.sqmValue = value;
            currentProperty.propertyValue = propertyValue;
        }

        // 🔁 Ora controlliamo tutte le altre proprietà figlie
        this.localValue.properties.forEach(prop => {
            if (prop.propertyName === propertyName) return; // salta quella modificata

            // Costruisco la lista attuale dei valori validi per questa property
            const allowedValues = this.filteredPropertyValues(prop.propertyName);

            // Se il valore attuale non è più valido e la property è dipendente (ha un parent), resetto
            const stillValid = allowedValues.some(v => v.identifier === prop.propertyValue);
            const isDependent = allowedValues.some(v => v.parent); // true se almeno uno ha parent

            if (!stillValid && isDependent) {
                prop.propertyValue = '';
                prop.sqmValue = { value: 0, isPercentage: false };
            }
        });

        // this.updateListCheck = Math.random();

        if (propertyName.toLocaleLowerCase().includes("eu"))
            this.$emit('EUSizeChanged', propertyValue);

        
        // if(!propertyValue)
        //     return;

        // var filteredValue = this.filteredValues.find( x => x.propertyName == propertyName);

        // var values = filteredValue.values;
        // var value = values.find( x => x.label == propertyValue).value;
        
        // var found = this.localValue.properties.find( x => x.propertyName == propertyName);
        // found.sqmValue = value;
        // found.propertyValue = propertyValue;

        // if(propertyName.toLocaleLowerCase().indexOf("eu") > -1)
        //     this.$emit('EUSizeChanged', propertyValue)
    }

    getTotal(index: number){
        var total = 0;

        for(var i = 0; i <= index; i++){
            var garmenProperty = this.localValue.properties[i];

            if(garmenProperty.sqmValue.isPercentage){
                total = total + total / 100 * garmenProperty.sqmValue.value;
            } else {
                total = total + garmenProperty.sqmValue.value;
            }
        }

        return total.toFixed(4);
    }
}
